import { TagToClassNameMap } from "~/lib/shared/html-utils";

export const tagToClassNameMap: TagToClassNameMap = new Map([
  ["p", "mb-m last:mb-0 text-body-large"],
  ["h1", "mb-m last:mb-0"],
  ["h2", "mb-m last:mb-0"],
  ["h3", "mb-m last:mb-0"],
  ["h4", "mb-m last:mb-0"],
  ["h5", "mb-xs last:mb-0"],
  ["ul", "mb-m last:mb-0 ml-m text-body-large"],
  ["ol", "mb-m last:mb-0 ml-m"],
  ["li", "list-disc list-outside mb-s last:mb-0"],
  [
    "a",
    "underline text-primary hover:text-primary-900 visited:text-primary-900",
  ],
  ["hr", "mb-m last:mb-0"],
]);
